import { 
    FETCH_LANGUAGE,
    FETCH_LANGUAGE_SUCCESS,
    FETCH_LANGUAGE_FAILED,
    FETCH_LANGUAGE_PACK_SUCCESS,
    EDIT_LANGUAGE
  } from "../store/types";
  
  // langlist: every language (id, langLocale, langName, dateLocale, default,
  // hash); keyValuePairs is present only for the packs actually loaded — the
  // default and the user's language, plus any the user switched to (see
  // common/src/actions/languageactions.js). full === true when every pack was
  // loaded (admin language editor, or the index-less fallback).
  export const INITIAL_STATE = {
    langlist:null,
    defaultLanguage:null,
    full: false,
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export const languagereducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_LANGUAGE:
        return {
          ...state,
          loading:true
        };
      case FETCH_LANGUAGE_SUCCESS: {
        const payload = action.payload || {};
        const next = {
          ...state,
          ...payload,
          full: payload.full === true,
          loading:false
        };
        // A partial refresh carries only the packs it loaded itself. Keep any
        // pack the store already holds for a listed language (one the user
        // switched to meanwhile, or a cached copy whose refresh failed) —
        // dropping it would put the app back in English. A kept pack whose
        // hash no longer matches the index loses its hash, so the saved cache
        // never presents it as current. Full payloads replace everything.
        if (payload.full !== true && Array.isArray(payload.langlist) && Array.isArray(state.langlist)) {
          const held = {};
          state.langlist.forEach((l) => {
            if (l && l.id && l.keyValuePairs && typeof l.keyValuePairs === 'object' && Object.keys(l.keyValuePairs).length) held[l.id] = l;
          });
          next.langlist = payload.langlist.map((l) => {
            if (!l || l.keyValuePairs || !held[l.id]) return l;
            return { ...l, keyValuePairs: held[l.id].keyValuePairs, hash: held[l.id].hash && held[l.id].hash === l.hash ? l.hash : null };
          });
        }
        return next;
      }
      case FETCH_LANGUAGE_PACK_SUCCESS: {
        // One more pack (the user switched language): merge it into its entry.
        const id = action.payload && action.payload.id;
        const pack = action.payload && action.payload.keyValuePairs;
        if (!id || !pack || !Array.isArray(state.langlist)) return state;
        let isDefault = false;
        const langlist = state.langlist.map((l) => {
          if (!l || l.id !== id) return l;
          isDefault = l.default === true;
          return { ...l, keyValuePairs: pack };
        });
        return {
          ...state,
          langlist,
          defaultLanguage: isDefault ? pack : state.defaultLanguage
        };
      }
      case FETCH_LANGUAGE_FAILED:
        // A failed REFRESH must not wipe a list that is already in use: the
        // phones hydrate /languages from the startup cache before the network
        // read, and a transient failure (no signal, Firebase "client is
        // offline" on a cold iOS start) used to null the list — which hides
        // the Login / Profile language pickers until the next cold start.
        return {
          ...state,
          langlist: state.langlist || null,
          defaultLanguage: state.defaultLanguage || null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      case EDIT_LANGUAGE:
        return state;
      default:
        return state;
    }
  };